import { Routes, Route } from "react-router-dom";
import PrivateAuth from '../../authorization/PrivateAuth';
import StockLedgerMain from '../../../pages/Reports/StockLedger/StockLedgerMain';
import WarehouseLedgerMain from '../../../pages/Reports/WarehouseLedger/WarehouseLedgerMain';
import PurchaseAnalytics from '../../../pages/Reports/PurchaseReport/PurchaseAnalytics/PurchaseAnalytics';
import PurchaseOrderAnalysis from '../../../pages/Reports/PurchaseReport/PurchaseOrderAnalysis/PurchaseOrderAnalysis';
import PurchaseOrderTrends from '../../../pages/Reports/PurchaseReport/PurchaseOrderTrends/PurchaseOrderTrends';
import ItemwisePurchaseHistory from '../../../pages/Reports/PurchaseReport/ItemwisePurchaseHistory/ItemwisePurchaseHistory';
import SalesAnalyticsReport from '../../../pages/Reports/SalesReport/SalesAnalyticsReport/SalesAnalyticsReport';
import SalesOrderAnalytics from '../../../pages/Reports/SalesReport/SalesOrderAnalytics/SalesOrderAnalytics';
import ItemwiseSalesHistory from '../../../pages/Reports/SalesReport/ItemwiseSalesHistory/ItemwiseSalesHistory';
import ItemsToOrderAndReceive from '../../../pages/Reports/PurchaseReport/ItemsToOrderAndReceive/ItemsToOrderAndReceive';
import SupplierWiseSalesAnalytics from '../../../pages/Reports/PurchaseReport/SupplierWiseSalesAnalytics/SupplierWiseSalesAnalytics';
import StockAnalytics from '../../../pages/Reports/WareHouseReport/StockAnalytics/StockAnalytics';
import DeliveryNoteTrends from '../../../pages/Reports/WareHouseReport/DeliveryNoteTrends/DeliveryNoteTrends';
import PurchaseReceiptTrends from '../../../pages/Reports/WareHouseReport/PurchaseReceiptTrends/PurchaseReceiptTrends';
import BatchWiseBalanceHistory from '../../../pages/Reports/WareHouseReport/BatchWiseBalanceHistory/BatchWiseBalanceHistory';
import WorkOrderSummary from '../../../pages/Reports/WareHouseReport/WorkOrderSummary/WorkOrderSummary';
import JobCardSummary from '../../../pages/Reports/WareHouseReport/JobCardSummary/JobCardSummary';
import BOMStockReport from '../../../pages/Reports/WareHouseReport/BOMStockReport/BOMStockReport';
import WorkOrderConsumedMaterials from '../../../pages/Reports/WareHouseReport/WorkOrderConsumedMaterials/WorkOrderConsumedMaterials';


function ReportRoute() {

    return (
        <Routes>
            <Route element={<PrivateAuth />}>
                <Route path="stock-ledger" element={<StockLedgerMain />} />
                <Route path="warehouse-ledger" element={<WarehouseLedgerMain />} />
                <Route path="purchase-analytics" element={<PurchaseAnalytics />} />
                <Route path="purchase-order-analytics" element={<PurchaseOrderAnalysis />} />
                <Route path="purchase-order-trends" element={<PurchaseOrderTrends />} />
                <Route path="item-wise-purchase-history" element={<ItemwisePurchaseHistory />} />
                <Route path="items-to-order-and-receive" element={<ItemsToOrderAndReceive />} />
                <Route path="supplier-wise-sales-analytics" element={<SupplierWiseSalesAnalytics />} />
                <Route path="sales-analytics-report" element={<SalesAnalyticsReport />} />
                <Route path="sales-order-analytics" element={<SalesOrderAnalytics />} />
                <Route path="item-wise-sales-history" element={<ItemwiseSalesHistory />} />
                <Route path="stock-analytics" element={<StockAnalytics />} />
                <Route path="delivery-note-trends" element={<DeliveryNoteTrends />} />
                <Route path="purchase-receipt-trends" element={<PurchaseReceiptTrends />} />
                <Route path="batch-wise-balance-history" element={<BatchWiseBalanceHistory />} />
                <Route path="work-order-summary" element={<WorkOrderSummary />} />
                <Route path="job-card-summary" element={<JobCardSummary />} />
                <Route path="bom-stock-report" element={<BOMStockReport />} />
                <Route path="work-order-consumed-materials" element={<WorkOrderConsumedMaterials />} />
            </Route>
        </Routes>
    )
}
export default ReportRoute